import ApiCall from "../constants/Api";
import SiteConfig from "../constants/SiteConfig";
import { helpAxios } from "../helpers/helpAxios";
import { errorHandler } from "../components/ErrorHandler";

export const useSelectFunctions = () => {
  //GetActiveTracksDate function
  const getActiveTracksDate = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_ACTIVE_TRACKS,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetRaces function
  const getRaces = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_RACES,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetEntries function
  const getEntries = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_ENTRIES,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetUpcomingRaces function
  const getUpcomingRaces = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_UPCOMING_RACES,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetRacesOff function
  const getRacesOff = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_OFF_RACES,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetRace function
  const getRace = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_RACE,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetCharts function
  const getChartsList = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_CHARTS,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetWagerTypesActivebyChart function
  const getActiveBetTypes = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_ACTIVE_BET_TYPES,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetOpenBetsbyChart function
  const getOpenBetsByChart = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_OPEN_BETS_CHART,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetPastPost function
  const getPastPost = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_PAST_POSTS,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetTracks function
  const getTracksList = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_TRACKS,
        request,
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetGameProviders function
  const getGameProviders = async (LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_GAME_PROVIDERS,
        {},
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetTrackCategory function
  const getTrackCategoryList = async (LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_TRACK_CATEGORY,
        {},
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetTrackAltCategory function
  const getTrackAltCategory = async (LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_ALT_TRACK_CATEGORY,
        {},
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetProfiles function
  const getProfilesList = async (LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_PROFILES,
        {},
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetBooks function
  const getBooksList = async (LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_BOOKS,
        {},
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetTracksByBook function
  const getTracksByBook = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_TRACKS_BY_BOOK,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetTracksByProfile function
  const getTracksByProfileList = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_TRACKS_BY_PROFILE,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetLimitSetList function
  const getLimitsSetList = async (LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_LIMIT_SET_LIST,
        {},
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetLimitSetID function
  const getLimitSetId = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_LIMIT_SET_ID,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetLimitSet function
  const getLimitsSet = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_LIMIT_SET,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetLastChange function
  const getLastChange = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.LOG_SVC,
        ApiCall.GET_LAST_CHANGES_LOG,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetChangesByField function
  const getChangesByField = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.LOG_SVC,
        ApiCall.GET_FIELD_CHANGES_LOG,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetPastPostTicketsByDate function
  const getPastPostTicketsByDateList = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_PAST_POST_TICKETS_BY_DATE,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetManualScoreQ function
  const getManualScoreTickets = async (LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_MANUALLY_SCORE_TICKETS,
        {},
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetSystemPreferencesRacing function
  const getSystemPreferencesRacing = async (LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_SYSTEM_PREFERENCES_RACING,
        {},
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetOpenBetsbyWT function
  const getOpenBetsByWT = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_OPEN_BETS_WT,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetCountries function
  const getCountriesList = async (LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_COUNTRIES,
        {},
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetStates function
  const getStatesList = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_STATES,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetAllStates function
  const getAllStatesList = async (LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_ALL_STATES,
        {},
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetMyIP function
  const getMyIP = async () => {
    let response;
    try {
      response = await helpAxios("", ApiCall.GET_MY_IP, {});

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetOpenBetsbyRaceID function
  const getOpenBetsByRaceID = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_OPEN_BETS_BY_RACE_ID,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetOpenBetsbyPeriodOfTime function
  const getOpenBetsByPeriodOfTime = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_OPEN_BETS_BY_PERIOD_OFF_TIME,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GET_RESULTS function
  const getResultsList = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_RESULTS,
        {
          ...request,
        },
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //GetTrackListEnabled function
  const getTrackListEnabled = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.GET_TRACK_LIST_ENABLED,
        request,
        LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  return {
    getActiveTracksDate,
    getRaces,
    getEntries,
    getUpcomingRaces,
    getRacesOff,
    getRace,
    getChartsList,
    getActiveBetTypes,
    getOpenBetsByChart,
    getPastPost,
    getTracksList,
    getGameProviders,
    getTrackCategoryList,
    getTrackAltCategory,
    getProfilesList,
    getBooksList,
    getTracksByBook,
    getTracksByProfileList,
    getLimitsSetList,
    getLimitSetId,
    getLimitsSet,
    getLastChange,
    getChangesByField,
    getPastPostTicketsByDateList,
    getManualScoreTickets,
    getSystemPreferencesRacing,
    getOpenBetsByWT,
    getCountriesList,
    getStatesList,
    getAllStatesList,
    getMyIP,
    getOpenBetsByRaceID,
    getOpenBetsByPeriodOfTime,
    getResultsList,
    getTrackListEnabled,
  };
};
